module.exports = __webpack_public_path__ + "img/apidays-2022-snapshot-1.f476951a.jpg";